import { FIELDS } from '@/pages/Requirements/constants';

const defaultFields = [
  {
    field: FIELDS.STATUS_NAME,
    title: 'Status',
    label: 'Status',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    field: FIELDS.ID,
    title: 'RFQ No',
    sortable: true,
    hidden: false,
    locked: true,
    width: 70,
  },
  {
    key: 'requirementDate',
    field: FIELDS.REQUIREMENT_DATE, //TODO: Update Constants
    title: 'RFQ Date',
    label: 'RFQ Date',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 80,
  },
  {
    key: 'companyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company',
    label: 'Company',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'contact',
    field: FIELDS.CONTACT_FULL_NAME,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'partNumber',
    field: FIELDS.PART_NUMBER,
    title: 'Part Number',
    label: 'Part Number',
    sortable: true,
    hidden: false,
    width: 200,
  },
  {
    key: 'customerPN',
    field: FIELDS.CUSTOMER_PN,
    title: 'Customer PN',
    label: 'Customer PN',
    sortable: true,
    hidden: false,
    width: 200,
  },
  {
    key: 'description',
    field: FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 400,
  },
  {
    key: 'mfgName',
    field: FIELDS.MFG_NAME,
    title: 'Mfr',
    label: 'Mfr',
    sortable: true,
    hidden: false,
    width: 300,
  },
  {
    key: 'quantity',
    field: FIELDS.QUANTITY,
    title: 'Qty',
    label: 'Qty',
    sortable: true,
    hidden: false,
    width: 65,
  },
  {
    field: FIELDS.BUYER_TARGET,
    title: 'Buyer Target',
    label: 'Buyer Target',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    key: 'conditionName',
    field: FIELDS.CONDITION_NAME,
    title: 'Condition',
    label: 'Condition',
    sortable: true,
    hidden: false,
    width: 125,
  },
  {
    key: 'comments',
    field: FIELDS.COMMENTS,
    title: 'Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 200,
  },
  {
    field: FIELDS.SHIPPING_PROVIDE_NAME,
    title: 'Delivery',
    label: 'Delivery',
    sortable: true,
    hidden: false,
    width: 100,
  }, 
  {
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Entered By',
    label: 'Entered By',
    sortable: true,
    hidden: false,
    width: 90,
  }, 
  {
    key: 'salesPersonUserFullName',
    field: FIELDS.SALES_PERSON_USER_FULL_NAME,
    title: 'Sales Rep',
    label: 'Sales Rep',
    sortable: true,
    hidden: false,
    width: 90,
  },
  {
    key: 'requirementFax',
    field: FIELDS.REQUIREMENT_FAX,
    title: 'Fax',
    label: 'Fax',
    sortable: true,
    hidden: true,
    width: 90,
  },
  {
    key: 'customerNote',
    field: FIELDS.CUSTOMER_NOTE,
    title: 'Customer Note',
    label: 'Customer Note',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'altNumber',
    field: FIELDS.ALT_NUMBER,
    title: 'Alt Number',
    label: 'Alt Number',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'internalPN',
    field: FIELDS.INTERNAL_PN,
    title: 'Internal PN',
    label: 'Internal PN',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'nSNNumber',
    field: FIELDS.N_SNNUMBER,
    title: 'NSN',
    label: 'NSN',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'sKU',
    field: FIELDS.S_KU,
    title: 'SKU',
    label: 'SKU',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'className',
    field: FIELDS.CLASS_NAME,
    title: 'Class',
    label: 'Class',
    sortable: true,
    hidden: true,
    width: 180,
  },
  {
    key: 'categoryName',
    field: FIELDS.CATEGORY_NAME,
    title: 'Category',
    label: 'Category',
    sortable: true,
    hidden: true,
    width: 180,
  },
  {
    key: 'package',
    field: FIELDS.PACKAGE,
    title: 'Package',
    label: 'Package',
    sortable: true,
    hidden: true,
    width: 180,
  },
  {
    key: 'piecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: 'PcsPerPkg/SPQ',
    label: 'PcsPerPkg/SPQ',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: FIELDS.fieldX,   //TODO: update constants
    title: 'Phys Pkg',
    label: 'Phys Pkg',
    sortable: true,
    hidden: true,
    width: 180,
  },
  {
    key: 'leadFree',
    field: FIELDS.LEAD_FREE,
    title: 'Lead Free',
    label: 'Lead Free',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'tempRating',
    field: FIELDS.TEMP_RATING,
    title: 'Temp Rate',
    label: 'Temp Rate',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'uoM',
    field: FIELDS.UO_M,
    title: 'UOM',
    label: 'UOM',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'partComments',
    field: FIELDS.PART_COMMENTS,
    title: 'Part Comments',
    label: 'Part Comments',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'dateCode',
    field: FIELDS.DATE_CODE,
    title: 'Date Code',
    label: 'Date Code',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'lotCode',
    field: FIELDS.LOT_CODE,
    title: 'Lot Code',
    label: 'Lot Code',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'revision',
    field: FIELDS.REVISION,
    title: 'Rev',
    label: 'Rev',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    key: 'price',
    field: FIELDS.PRICE,
    title: 'Price',
    label: 'Price',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'currencyTypeName',
    field: FIELDS.CURRENCY_TYPE_NAME,
    title: 'Currency',
    label: 'Currency',
    sortable: true,
    hidden: true,
    width: 90,
  },
  {
    key: 'convertedPrice',
    field: FIELDS.CONVERTED_PRICE,
    title: 'Conv Price',
    label: 'Conv Price',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'exchangeRate',
    field: FIELDS.EXCHANGE_RATE,
    title: 'Exchg Rate',
    label: 'Exchg Rate',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'vendorNote',
    field: FIELDS.VENDOR_NOTE,
    title: 'Vendor Note',
    label: 'Vendor Note',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'needByDate',
    field: FIELDS.NEED_BY_DATE, //TODO: should not display time
    title: 'Needs By',
    label: 'Needs By',
    sortable: true,
    hidden: true,
    width: 120,
  },
  {
    key: 'testingRequested',
    field: FIELDS.TESTING_REQUESTED,
    title: 'Testing Rqstd',
    label: 'Testing Rqstd',
    sortable: true,
    hidden: true,
    width: 90,
  },
  {
    field: FIELDS.fieldX,      //TODO: update constants
    title: 'Ship Via',
    label: 'Ship Via',
    sortable: true,
    hidden: true,
    width: 150,
  }, 
  {
    key: 'dateCreated',
    field: FIELDS.DATE_CREATED,   //TODO: should not display time
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: true,
    width: 80,
  },
  // {
  //   key: 'createdByUserFullName',
  //   field: FIELDS.CREATED_BY_USER_FULL_NAME,
  //   title: 'Created By',
  //   label: 'Created By',
  //   sortable: true,
  //   hidden: true,
  //   width: 90,
  // },
  {
    key: 'dateModified',
    field: FIELDS.DATE_MODIFIED,  //TODO: should not display time
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: true,
    width: 80,
  },
  {
    key: 'modifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: true,
    width: 90,
  },
  {
    key: 'active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 50,
  },

  // {
  //   key: 'referalSourceName',
  //   field: FIELDS.REFERAL_SOURCE_NAME,
  //   title: 'Source',
  //   label: 'Source',
  //   sortable: true,
  //   hidden: true,
  //   width: 150,
  // },  
]

export default defaultFields;
